import React from 'react'

import type { SpaceProps } from '../../../../themes'
import { renderChildrenWithProps } from '../../../../utils/renderChildrenWithProps'
import { Collapsible } from '../../../Collapsible'
import type { CardProps } from '../../index'
import { CardContainer, Container } from './styles'

type SubCardElement =
  | React.ReactElement<CardProps>
  | null
  | undefined
  | boolean
  | ''

export interface CardContentCardListProps extends SpaceProps {
  className?: string
  openCollapsed?: boolean
  collapsedCards?: React.ReactElement<CardProps>[]
  children: SubCardElement | SubCardElement[]
}

const renderSubCards = (children: SubCardElement | SubCardElement[]) => {
  return renderChildrenWithProps(children, {
    // Force horizontal-embedded layout
    layout: 'horizontal-embedded',
  })
}

export const CardContentCardList = ({
  className,
  openCollapsed,
  collapsedCards,
  children,
  ...spaceProps
}: CardContentCardListProps) => {
  return (
    <Container className={className} {...spaceProps}>
      <CardContainer>{renderSubCards(children)}</CardContainer>

      {collapsedCards && (
        <Collapsible open={openCollapsed}>
          <CardContainer disableTopBorder>
            {renderSubCards(collapsedCards)}
          </CardContainer>
        </Collapsible>
      )}
    </Container>
  )
}
